export default {
  verificaCpfCnpj: function verificaCpfCnpj (valor) {
    valor = valor.toString()
    valor = valor.replace(/[^0-9]/g, '')

    if (valor.length === 11) {
      return 'CPF'
    } else if (valor.length === 14) {
      return 'CNPJ'
    } else {
      return false
    }
  },

  calcDigitosPosicoes: function calcDigitosPosicoes (digitos, posicoes = 10, somaDigitos = 0) {
    digitos = digitos.toString()
    for (var i = 0; i < digitos.length; i++) {
      somaDigitos = somaDigitos + (digitos[i] * posicoes)

      posicoes--

      if (posicoes < 2) {
        posicoes = 9
      }
    }

    somaDigitos = somaDigitos % 11

    if (somaDigitos < 2) {
      somaDigitos = 0
    } else {
      somaDigitos = 11 - somaDigitos
    }
    var cpf = digitos + somaDigitos

    return cpf
  },

  validaCpf: function validaCpf (valor) {
    var novoCpf
    valor = valor.toString()
    valor = valor.replace(/[^0-9]/g, '')

    var digitos = valor.substr(0, 9)

    novoCpf = this.calcDigitosPosicoes(digitos)
    novoCpf = this.calcDigitosPosicoes(novoCpf, 11)
    if (novoCpf === valor) {
      return true
    } else {
      return false
    }
  },
  validaCnpj: function validaCnpj (valor) {
    valor = valor.toString()

    valor = valor.replace(/[^0-9]/g, '')

    var cnpjOriginal = valor

    var primeirosNumerosCnpj = valor.substr(0, 12)

    var primeiroCalculo = this.calcDigitosPosicoes(primeirosNumerosCnpj, 5)

    var segundoCalculo = this.calcDigitosPosicoes(primeiroCalculo, 6)

    var cnpj = segundoCalculo

    if (cnpj === cnpjOriginal) {
      return true
    }

    return false
  },
  validaCpfCnpj: function validaCpfCnpj (valor) {
    var valida = this.verificaCpfCnpj(valor)
    valor = valor.toString()

    valor = valor.replace(/[^0-9]/g, '')

    if (valida === 'CPF') {
      return this.validaCpf(valor)
    } else if (valida === 'CNPJ') {
      return this.validaCnpj(valor)
    } else {
      return false
    }
  },

  formataCpfCnpj: function formataCpfCnpj (valor) {
    var formatado = false

    var valida = this.verificaCpfCnpj(valor)

    valor = valor.toString()

    valor = valor.replace(/[^0-9]/g, '')

    if (valida === 'CPF') {
      if (this.validaCpf(valor)) {
        formatado = valor.substr(0, 3) + '.'
        formatado += valor.substr(3, 3) + '.'
        formatado += valor.substr(6, 3) + '-'
        formatado += valor.substr(9, 2) + ''
      }
    } else if (valida === 'CNPJ') {
      if (this.validaCnpj(valor)) {
        formatado = valor.substr(0, 2) + '.'
        formatado += valor.substr(2, 3) + '.'
        formatado += valor.substr(5, 3) + '/'
        formatado += valor.substr(8, 4) + '-'
        formatado += valor.substr(12, 14) + ''
      }
    }
    return formatado
  }
}



// WEBPACK FOOTER //
// ./src/plugins/cpfCnpj.js